import * as Yup from 'yup';

export const signInSchema = Yup.object().shape({
    email: Yup.string().required('Please enter your email'),
    password: Yup.string().required('Please enter your password'),
    role:Yup.string().required('Please select role')
});
